/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import AppContainer from "../../../Components/Structure/AppContainer";
import Loader from "../../../Components/Common/Loader";
import TableHeader from "../../../Components/Common/TableHeader";
import CreditBalancesSearchForm from "../../../Components/Common/Statistics/CreditBalancesSearchForm";
import Pagination from "../../../Components/Common/Pagination";
import ajaxVendor from "../../../util/remote/ajaxVendor";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useStateCallback from "../../../util/customHooks/useStateCallback";
import CommissionsFilterForm from "../../../Components/Common/Transactions/CommissionsFilterForm";


function VendorCommissionsPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [overallVendorCommissionBalance, setOverallVendorCommissionBalance] = useState(false);
    const [vendorCommissionBalances, setVendorCommissionBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [meta, setMeta] = useState([]);
    const [modal, setModal] = useStateCallback(false);
    useEffect(() => {
        if (query || school ) {
            searchVendorCommissionBalances();
        } else {
            getVendorCommissionBalances(page);
        }
    }, [page]);

    useEffect(() => {
            getOverallVendorCommissionBalance();
    }, []);

    const getOverallVendorCommissionBalance = async () => {
        const server_response = await ajaxBank.fetchOverallVendorCommissionBalance();
        if (server_response.status === "OK") {
            setOverallVendorCommissionBalance(server_response.details);
        } else {
            setOverallVendorCommissionBalance("404");
        }
    };
  
    const getVendorCommissionBalances = async (currentPage) => {
        setLoading(true);
        const server_response = await ajaxVendor.listAllCommissionBalances(currentPage);
        setLoading(false);

        if (server_response.status === "OK") {
            setFirst(server_response.details.meta.offset);
            setMeta(server_response.details.meta.totalPages);
            setVendorCommissionBalances(server_response.details.data || []);
        } else {
            setVendorCommissionBalances([]);
        }
    };

    const searchVendorCommissionBalances = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setLoading2(true);
        const server_response = await ajaxVendor.searchAllCommissionBalances(page, school, query);
        setLoading2(false);
        if (server_response.status === "OK") {
            setMeta(server_response.details.meta.totalPages);
            setVendorCommissionBalances(server_response.details.data || []);
        } else {
            setVendorCommissionBalances([]);
        }
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setPage(1);
    getVendorCommissionBalances(1);
    
  };

  const filterStats = (e, item) => {
      setModal(false, () => setModal(<CommissionsFilterForm user={item.user} userID={item.user_id} username={item.username}
          balance={item.balance.total_c} isOpen={true}/>));
    }


  return (
    <AppContainer title="Vendor Commission Balances">
      <Toaster position="top-center" reverseOrder={false} />
        {modal}
       
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {overallVendorCommissionBalance? overallVendorCommissionBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Commission Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Commission Balances List"
          subtitle="List of all the vendors with their commission balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link> 
        </div>
      </div>

      <CreditBalancesSearchForm school={school} student={query} setSchool={setSchool} setStudent={setQuery}
      searchCreditBalances={searchVendorCommissionBalances} setPage={setPage} resetSearch={setBalances} schoolList={schoolList}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Vendor Name</th>
                <th scope="col">Username</th>

                <th scope="col"> School</th>
                <th scope="col"> Commission Balance</th>
                
                </tr>
            </thead>
            <tbody>
                {vendorCommissionBalances.length > 0 ? (
                    vendorCommissionBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link onClick={(e) => filterStats(e,item)}>{item.user}
                                                                </Link></OverlayTrigger></td>
                      
                        
                        <td>{item.username}</td>

                        <td>{item.school}</td>
                        <td>UGX. {item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No vendors registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            
        </div>
        

        
      
    </AppContainer>
  );
}

export default VendorCommissionsPage;
